import { useTranslation } from 'react-i18next';
import BasicSnackBar from './BasicSnackBar';
import { closeResetOrientationAcknowledgement, useResetOrientationAcknowledgementState } from './resetOrientationAcknowledgementNotification';
import { bottomCenterSnackbarStackSx } from './snackbarStyles';

interface ResetOrientationAcknowledgementSnackbarProps {
  stackIndex?: number;
}

const ResetOrientationAcknowledgementSnackbar = ({ stackIndex }: ResetOrientationAcknowledgementSnackbarProps) => {
  const { t } = useTranslation();
  const { open, nonce, variant } = useResetOrientationAcknowledgementState();
  const message =
    variant === 'error'
      ? t('resetOrientationButton.snackbar.unavailable', 'Unable to reset drive unit orientation')
      : t('resetOrientationButton.snackbar.acknowledgement', 'Drive unit orientation reset');

  return (
    <BasicSnackBar
      key={nonce}
      message={message}
      vertical="bottom"
      horizontal="center"
      open={open}
      onClose={closeResetOrientationAcknowledgement}
      disableStackRegistration={stackIndex !== undefined}
      contentSx={
        variant === 'error'
          ? (theme) => ({
              backgroundColor: theme.vars?.palette?.background?.paper ?? theme.palette.background.paper,
              color: theme.vars?.palette?.error?.main ?? theme.palette.error.main,
            })
          : undefined
      }
      sx={stackIndex === undefined ? undefined : bottomCenterSnackbarStackSx(stackIndex)}
    />
  );
};

export default ResetOrientationAcknowledgementSnackbar;
